module.exports = __webpack_public_path__ + "img/face-disguise.a0d2d3f5.svg";